import { LayersActions } from "actions";
import ViewerEvents from "./ViewerEvents";
import { getAttributes, getAttributesValues, getComponentId } from "actions/GlobalActions";

export default class DomEvents {
    static clickEventHook: boolean;
    static keyEventHook: boolean;
    static skipRaycast: boolean = false;
    static pointerPressed: boolean = false;
    static pointerDownPageX: number = 0;
    static pointerDownPageY: number = 0;

    static on(event: string, hook: any) {
        document.addEventListener(event, hook);
    }

    static removeEventListener(event: string, hook: any) {
        document.removeEventListener(event, hook);
    }

    static onRaycastHit(event: any) {
        DomEvents.bind(this);
    }

    static setClickEventHook(hook: boolean) {
        DomEvents.clickEventHook = hook;
    }

    static setKeyEventHook(hook: boolean) {
        DomEvents.keyEventHook = hook;
    }

    static onMouseDown(event: any) {
        DomEvents.skipRaycast = false;
        DomEvents.pointerPressed = true;
        DomEvents.pointerDownPageX = event.pageX;
        DomEvents.pointerDownPageY = event.pageY;
    }

    static onMouseMove(event: any) {
        if (DomEvents.pointerPressed) {
            //Preventing Raycast During Click Event Hook, Based On A Certain Amount Of Drag
            //Note: Additionaly we could check for if the viewer is panning or rotating..
            const pointerDragThreshold = 0.02;
            const pointerDragPageX: number = event.pageX;
            const pointerDragPageY: number = event.pageY;
            const pointerDragAmountX = Math.abs(pointerDragPageX - DomEvents.pointerDownPageX);
            const pointerDragAmountY = Math.abs(pointerDragPageY - DomEvents.pointerDownPageY);
            if (pointerDragAmountX > pointerDragThreshold || pointerDragAmountY > pointerDragThreshold) {
                DomEvents.skipRaycast = true;
            }
        }
    }

    static onKeyDown(event: any) {
        DomEvents.bind(this);
    }

    static onMouseUp(event: any) {
        DomEvents.pointerPressed = false;
    }

    static onMouseClick(event: any) {
        var element = event.target;
        //console.log("element:", element.tagName, "|DomEvents.clickEventHook:", DomEvents.clickEventHook);
        if (
            (element.tagName === "CANVAS" ||
                (event.srcElement.firstChild && event.srcElement.firstChild.tagName === "CANVAS")) &&
            DomEvents.clickEventHook
        ) {
            const viewer = ViewerEvents.viewer;
            if (viewer && !DomEvents.skipRaycast) {
                const raycastViewResult = viewer.raycastViewPrimitives(event.pageX, event.pageY);
                const raycastSceneResult = viewer.raycastSceneUnits(event.pageX, event.pageY);

                console.log("raycastViewResult:", raycastViewResult);
                console.log("raycastSceneResult:", raycastSceneResult);

                const hitPrimitives = raycastViewResult !== null && raycastViewResult.valid;
                const hitUnits = raycastSceneResult !== null && raycastSceneResult.valid;

                if (hitPrimitives || hitUnits) {
                    let sendPrimitiveEventData = false;

                    if (hitPrimitives && hitUnits) {
                        //Picking the closest hit
                        const internalPrimitiveHitDistance = raycastViewResult.internalData.distance;
                        const internalUnitHitDistance = raycastSceneResult.internalData.distance;
                        sendPrimitiveEventData = internalPrimitiveHitDistance < internalUnitHitDistance;
                    } else if (hitPrimitives) {
                        sendPrimitiveEventData = true;
                    } //if (hitUnits)
                    else {
                        sendPrimitiveEventData = false;
                    }

                    //Collecting attribute names if exist
                    //Ignoring if realtime terrain
                    var attributeNames: any = [];
                    const { compositeMeta } = ViewerEvents;
                    const layerIndex: number = raycastViewResult.layerId;
                    const component = compositeMeta.components[layerIndex];
                    const entityId: string = getComponentId(layerIndex);
					const sourceId: string = component.source;
                    console.log("%c===>entityId:", "color:orange", entityId);
                    const collectAttributes: boolean =
                        entityId !== null && !(sendPrimitiveEventData && raycastViewResult.realtimeTerrain);

                    if (collectAttributes) {
                        if (component) {
                            if (component.attributeNames && component.attributeName !== null) {
                                attributeNames = component.attributeNames;
                            } else if (LayersActions.entitiesData[entityId]) {
                                const data = LayersActions.entitiesData[entityId];
                                attributeNames = data.map((info: any) => info.name);
                            } else {
                                var layerId = component.source;
                                if (layerId) {
                                    attributeNames = getAttributes(layerId);
                                }
                            }
                        }
                    }

                    if (sendPrimitiveEventData) {
                        //Collecting attribute values if exist
                        var attributeValues: any = [];
                        var alphaAttributes: any = [];
                        // if (entityId !== null) {
                        //     alphaAttributes = getAttributesValues(entityId) || null;
                        // }
						if (sourceId !== null) {
							alphaAttributes = getAttributesValues(sourceId) || null;
						}
                        switch (raycastViewResult.dataType) {
                            case "surface":
								break;
                            case "point":
                            case "block":
                            case "collar":
                                break;
                            case "trace":
                                attributeValues = [...raycastViewResult.data.segmentAttributeValues];
                                break;
                            case "cylinder":
                                attributeValues = [...raycastViewResult.data.segmentAttributeValues];
                                break;
                            case "geoChemCollar":
                                attributeValues = [...raycastViewResult.data.collarAttributeValues];
                                break;
                        }
                        if (attributeValues.length > 0 && alphaAttributes.length > 0) {
                            attributeValues.forEach((value: number, index: number) => {
                                var alphaAttribute = alphaAttributes.find((alpha: any) => alpha.index === index);
                                if (alphaAttribute) {
                                    attributeValues[index] = alphaAttribute.values[value];
                                }
                            });
                        }

                        //Firing onRaycastHit with primitive data
                        const primitiveEventData: any = {
                            type: raycastViewResult.dataType,
                            data: raycastViewResult.data,
                            cellId: raycastViewResult.cellId,
                            layerId: raycastViewResult.layerId,
                            entityId,
							sourceId,
                            worldPoint: raycastViewResult.worldPoint,
                            customAttributeNames: attributeNames,
                            customAttributeValues: attributeValues,
                            alphaAttributes: alphaAttributes,
                        };
                        DomEvents.onRaycastHit(primitiveEventData);
                    } //if (sendUnitEventData)
                    else {
                        switch (raycastSceneResult.dataType) {
                            case "unit":
                                break;
                        }

                        const unitType: number = raycastSceneResult.data.unitType;
                        const unitLayerId: string = raycastSceneResult.data.unitLayerId;
                        const unitTimestamp: number = raycastSceneResult.data.unitTimestamp;
                        const unitRuntimeParams: Map<string, string> = raycastSceneResult.data.unitRuntimeParams;

                        const customAttributeNames: Array<string> = [];
                        const customAttributeValues: Array<any> = [];

                        //customAttributeNames.push("unitId");
                        //customAttributeValues.push(unitId);
                        customAttributeNames.push("unitTimestamp");
                        customAttributeValues.push(unitTimestamp);

                        //Note: uncomment once attribute names match unit param names
                        //Most of them are; however some names or values have special symbols..
                        //Because of that, some params will be missing in the panel
                        /*const attributeCount: number = attributeNames.length;
                        for (let attributeIndex: number = 0; attributeIndex < attributeCount; ++attributeIndex)
                        {
                            const attributeName: string = attributeNames[attributeIndex];
                            
                            if (unitRuntimeParams.has(attributeName))
                            {
                                const customAttributeName: string = decodeURI(attributeName);
                                const customAttributeValue: any = unitRuntimeParams.get(attributeName);
                                customAttributeNames.push(customAttributeName);
                                customAttributeValues.push(customAttributeValue);
                            }
                            else
                            {
                                //Comment if you don't want to display missing attribute values
                                const customAttributeName: string = decodeURI(attributeName);
                                const customAttributeValue: any = "-";
                                customAttributeNames.push(customAttributeName);
                                customAttributeValues.push(customAttributeValue);
                            }
                        }*/

                        //Note: this may not be in the same order as in the extended meta..
                        unitRuntimeParams.forEach(function (paramValue, paramKey, map) {
                            const customAttributeName: string = decodeURI(paramKey);
                            const customAttributeValue: string = paramValue;
                            customAttributeNames.push(customAttributeName);
                            customAttributeValues.push(customAttributeValue);
                        });

                        //Firing onRaycastHit with unit data
                        const unitEventData: any = {
                            type: raycastSceneResult.dataType,
                            data: raycastSceneResult.data,
                            layerId: unitLayerId,
                            unitType: unitType,
                            worldPoint: raycastSceneResult.worldPoint,
                            customAttributeNames: customAttributeNames,
                            customAttributeValues: customAttributeValues,
                        };
                        DomEvents.onRaycastHit(unitEventData);
                    }
                }
            }
        }
    }
}
